import AIQAStore from "@/store/AIQA.store";
import summaryCommonStore from "@/store/summaryCommon.store";
import { getUser } from "@/store/user.store";
import { useEffect } from "react";
import { DetailErrorType } from "@/constants/record";
import Main from "@/sections/WebSummary/Main";
import Header from "./components/Header";
import useSummaryPage from "@/sections/Summary/useSummaryPage";

const Web = () => {
  const errorStatus = summaryCommonStore((state) => state.errorStatus);
  useSummaryPage();

  useEffect(() => {
    getUser();
    AIQAStore.getState().toggleAIQAMode(false, true);
  }, []);

  return (
    <div className="w-full h-full flex flex-col">
      <Header
        titleEditable
        isOnlyBack={errorStatus === DetailErrorType.deleted || errorStatus === DetailErrorType.ERR_NETWORK}
      />
      <div className="flex-1 overflow-hidden">
        <Main />
      </div>
    </div>
  );
};

export default Web;
